import axios from 'axios';

import { serviceAccountErrorCallback } from '../callbacks';
import { API_V1_GET_ROLES } from './constants';

export function getRolesV1({ params }) {
  return axios
    .get(API_V1_GET_ROLES, { withCredentials: false, params })
    .catch(serviceAccountErrorCallback);
}
